var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Import Customer"}},[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Customer"}},[_c('div',{staticClass:"tab-text"},[_c('customer')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }